import {View, ViewRegistry} from "@lernetz/ts-lib";
import {languageService} from "../../services/lang";
import {MagicWand} from "./MagicWand.component";
import template from "./WizardStart.html";

const registry = new ViewRegistry();
registry.add('MagicWand', () => MagicWand);

export class WizardStart extends View {
    constructor() {
        super({
            template, registry
        });
    }
    init() {
        this.data.currentLang = languageService.currentLang;
    }
}


